import React from 'react'
import PropTypes from 'prop-types'
import { Nav, NavItem } from 'reactstrap'
import { Scrollbars } from 'react-custom-scrollbars'
import { SidebarContainer } from '../sidebar-container'
import { SidebarLink } from '../sidebar-link'
import { SessionStore } from '../../stores/session'
import { inject, observer } from 'mobx-react'

class CustomScrollbars extends React.Component {
  constructor (props, context) {
    super(props, context)
    this.state = {
      hover: false
    }
  }

  render () {
    return (
      <Scrollbars universal
        renderThumbVertical={({ style, ...props }) =>
          <div {...props} style={{ ...style, backgroundColor: 'rgba(255,255,255,0.2)' }} />
        }>
        {this.props.children}
      </Scrollbars>
    )
  }
}

@inject('sessionStore')
@observer
class SidebarHelp extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      ready: false,
      roles: null
    }
  }

  render () {
    if (this.props.sessionStore.isBaseEdition) {
      return (
        <SidebarContainer>
          <CustomScrollbars
            autoHeight
            autoHeightMin={0}
            autoHeightMax={'calc(100vh - 70px)'}
            style={{ width: 250 }}>
            <div className='sidebar my-4'>
              <div className='nav-sidebar w-100' aria-label='sidebar' role='navigation' id='sidebarNav'>
                <Nav vertical>
                  <NavItem>
                    <SidebarLink to='/' url={this.props.url}>
                      <svg className='icon' aria-hidden='true'><use xlinkHref='#home' href='#home' /></svg>
                      <div>Home</div>
                    </SidebarLink>
                  </NavItem>
                  <NavItem>
                    <SidebarLink to='/help' url={this.props.url}>
                      <svg className='icon' aria-hidden='true'><use xlinkHref='#help' href='#help' /></svg>
                      <div>Help</div>
                    </SidebarLink>
                  </NavItem>
                  <NavItem>
                    <SidebarLink to='/help' anchor='fms-page'>
                      <svg className='icon' aria-hidden='true'><use xlinkHref='#data_configuration' href='#data_configuration' /></svg>
                      <div>FMS connections</div>
                    </SidebarLink>
                  </NavItem>
                  <NavItem>
                    <SidebarLink to='/help' anchor='imports'>
                      <svg className='icon' aria-hidden='true'><use xlinkHref='#import' href='#import' /></svg>
                      <div>Import</div>
                    </SidebarLink>
                  </NavItem>
                  <NavItem>
                    <SidebarLink to='/help' anchor='amendment'>
                      <mosaic-icon name='accounting' />
                      <div>VAT100 amendment</div>
                    </SidebarLink>
                  </NavItem>
                  <NavItem>
                    <SidebarLink to='/help' anchor='status-of-tiles-explained'>
                      <svg className='icon' aria-hidden='true'><use xlinkHref='#tiles' href='#tiles' /></svg>
                      <div>Status of tiles explained</div>
                    </SidebarLink>
                  </NavItem>
                  <NavItem>
                    <SidebarLink to='/help' anchor='type-of-errors'>
                      <svg className='icon' aria-hidden='true'><use xlinkHref='#error' href='#error' /></svg>
                      <div>Type of errors</div>
                    </SidebarLink>
                  </NavItem>
                </Nav>
              </div>
            </div>
          </CustomScrollbars>
        </SidebarContainer>
      )
    } else if (this.props.sessionStore.isFullEdition) {
      return (
        <SidebarContainer>
          <CustomScrollbars
            autoHeight
            autoHeightMin={0}
            autoHeightMax={'calc(100vh - 70px)'}
            style={{ width: 250 }}>
            <div className='sidebar my-4'>
              <div className='nav-sidebar w-100' aria-label='sidebar' role='navigation' id='sidebarNav'>
                <Nav vertical>
                  <NavItem>
                    <SidebarLink to='/' url={this.props.url}>
                      <svg className='icon' aria-hidden='true'><use xlinkHref='#home' href='#home' /></svg>
                      <div>Home</div>
                    </SidebarLink>
                  </NavItem>
                  <NavItem>
                    <SidebarLink to='/help' anchor='gettingstarted'>
                      <svg className='icon' aria-hidden='true'><use xlinkHref='#settings' href='#settings' /></svg>
                      <div>Getting Started </div>
                    </SidebarLink>
                  </NavItem>
                  <NavItem>
                    <SidebarLink to='/help' anchor='reconciliation'>
                      <mosaic-icon name='scales' />
                      <div>Reconciliation </div>
                    </SidebarLink>
                  </NavItem>
                  <NavItem>
                    <SidebarLink to='/help' anchor='fms-page'>
                      <svg className='icon' aria-hidden='true'><use xlinkHref='#data_configuration' href='#data_configuration' /></svg>
                      <div>FMS connections</div>
                    </SidebarLink>
                  </NavItem>
                  <NavItem>
                    <SidebarLink to='/help' anchor='imports'>
                      <svg className='icon' aria-hidden='true'><use xlinkHref='#import' href='#import' /></svg>
                      <div>Import</div>
                    </SidebarLink>
                  </NavItem>
                  {this.props.sessionStore.isFullEdition &&
                  <NavItem>
                    <SidebarLink to='/help' anchor='enhancedsearch'>
                      <svg className='icon' aria-hidden='true'><use xlinkHref='#search' href='#search' /></svg>
                      <div>Enhanced search</div>
                    </SidebarLink>
                  </NavItem>
                  }
                  <NavItem>
                    <SidebarLink to='/help' anchor='status-of-tiles-explained'>
                      <svg className='icon' aria-hidden='true'><use xlinkHref='#tiles' href='#tiles' /></svg>
                      <div>Status of tiles explained</div>
                    </SidebarLink>
                  </NavItem>
                  <NavItem>
                    <SidebarLink to='/help' anchor='type-of-errors'>
                      <svg className='icon' aria-hidden='true'><use xlinkHref='#error' href='#error' /></svg>
                      <div>Type of errors</div>
                    </SidebarLink>
                  </NavItem>
                  <NavItem>
                    <SidebarLink to='/help' anchor='audit'>
                      <svg className='icon'><use xlinkHref='#clock' href='#clock' /></svg>
                      <div>Audit</div>
                    </SidebarLink>
                  </NavItem>
                  <NavItem>
                    <SidebarLink to='/help' anchor='adjustments'>
                      <svg className='icon' aria-hidden='true'><use xlinkHref='#accounting_' href='#accounting_' /></svg>
                      <div>Adjustments</div>
                    </SidebarLink>
                  </NavItem>
                  <NavItem>
                    <SidebarLink to='/help' anchor='journal'>
                      <svg className='icon' aria-hidden='true'><use xlinkHref='#accounting_' href='#accounting_' /></svg>
                      <div>Journals</div>
                    </SidebarLink>
                  </NavItem>
                  <NavItem>
                    <SidebarLink to='/help' anchor='configuration'>
                      <svg className='icon' aria-hidden='true'><use xlinkHref='#settings' href='#settings' /></svg>
                      <div>Configuration</div>
                    </SidebarLink>
                  </NavItem>
                  <NavItem>
                    <SidebarLink to='/help' anchor='setupataxcode'>
                      <svg className='icon' aria-hidden='true'><use xlinkHref='#tags' href='#tags' /></svg>
                      <div>Tax codes</div>
                    </SidebarLink>
                  </NavItem>
                  <NavItem>
                    <SidebarLink to='/help' anchor='taxcodemapping'>
                      <svg className='icon' aria-hidden='true'><use xlinkHref='#mosaic_icon_map' href='#mosaic_icon_map' /></svg>
                      <div>Tax code mapping</div>
                    </SidebarLink>
                  </NavItem>
                  {this.props.sessionStore.isFullEdition &&
                  <NavItem>
                    <SidebarLink to='/help' anchor='resultscolumnorder'>
                      <mosaic-icon name='columns'/>
                      <div>Results column order</div>
                    </SidebarLink>
                  </NavItem>
                  }
                  <NavItem>
                    <SidebarLink to='/help' anchor='layouts'>
                      <svg className='icon' aria-hidden='true'><use xlinkHref='#form' href='#form' /></svg>
                      <div>Layout</div>
                    </SidebarLink>
                  </NavItem>
                  <NavItem>
                    <SidebarLink to='/help' anchor='users'>
                      <svg className='icon' aria-hidden='true'><use xlinkHref='#user_group_man_man' href='#user_group_man_man' /></svg>
                      <div>Users</div>
                    </SidebarLink>
                  </NavItem>
                  <NavItem>
                    <SidebarLink to='/help' anchor='changepassword'>
                      <svg className='icon' aria-hidden='true'><use xlinkHref='#password' href='#password' /></svg>
                      <div>Change password</div>
                    </SidebarLink>
                  </NavItem>
                  <NavItem>
                    <SidebarLink to='/help' anchor='tolerance'>
                      <svg className='icon' aria-hidden='true'><use xlinkHref='#exposure_value' href='#exposure_value' /></svg>
                      <div>Tolerances</div>
                    </SidebarLink>
                  </NavItem>
                  <NavItem>
                    <SidebarLink to='/help' anchor='workflows'>
                      <svg className='icon' aria-hidden='true'><use xlinkHref='#workflow' href='#workflow' /></svg>
                      <div>Workflow</div>
                    </SidebarLink>
                  </NavItem>
                </Nav>
              </div>
            </div>
          </CustomScrollbars>
        </SidebarContainer>
      )
    }
  }
}

SidebarHelp.propTypes = {
  url: PropTypes.object,
  sessionStore: PropTypes.instanceOf(SessionStore)
}

export { SidebarHelp }
